import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import './FutureDetailsRow.css'
import { setSelectedChars } from '../../../actions/data.js'
import { getSelectedChars } from '../../../reducers/data.js'


class FutureDetailsRow extends Component {
  state = { showing: false }

  formatPercent(number) {
    return number !== null && isNaN(number) === false ? `${parseFloat(number * 100).toFixed(1)}%` : '-'
  }
  formatDecimal(number) {
    return number !== null ? parseFloat(number).toFixed(2) : '-'
  }
  formatNumber(number) {
    return number !== null ? parseFloat(number).toFixed(0) : '-'
  }

  setSelectedChars(char) {
    this.props.setSelectedChars(char)
    this.setState({ showing: !this.state.showing })
  }

  render() {
    const { data } = this.props
    let charName = data.entity



    return (
      <Fragment>
        <tr>
          <td className={'td-textLeft'}>
            <div >{charName}
            </div>
          </td>
          <td className={'td-textCenter'}>
            {data.periodTag}
          </td>
          <td className={'td-textCenter'}>
            {this.formatPercent(data.ebitCalYrGrw)}
          </td>
          <td className={'td-textCenter'}>
            {this.formatPercent(data.salesCalYrGrw)}
          </td>
          {/* <td className={'td-textCenter'}>
            {this.formatPercent(data.cf_opCalYrGrw)}
          </td> */}
        </tr>
      </Fragment >
    )
  }
}

function mapStateToProps(state) {
  return {
    selectedChars: getSelectedChars(state),
    earningsAggsFuture: state.data.earningsAggsFuture,
    earningsAggsAll: state.data.earningsAggsAll,
    earningsType: state.data.earningsType,
    growthType: state.data.growthType,
    selectedPeriodOption: state.data.selectedPeriodOption,
    selectedRangeOption: state.data.selectedRangeOption,
    selectedEntityOptionFuture: state.data.selectedEntityOptionFuture
  }
}

export default connect(mapStateToProps, {
  setSelectedChars
})(FutureDetailsRow)



// WEBPACK FOOTER //
// ./src/components/App/FutureDetailsTable/FutureDetailsRow.js